import { PlanType } from '@/enums';
import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';


export const InternationalPostTripMedical = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'postTripph',
  });


  return {
    title: t('title'),
    coverages: [
      {
        baggageCoverage: {
          parentCoverage: {
            label: t('international.description'),
            remarks: t('remarks', { returnObjects: true }),
            insuredAmountData: [
              {
                classId: 1,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 2,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 3,
                amount: '',
                remark: null,
                colspan: 1,
              },
            ],
          },
          childrenCoverage: [
            {
              label: t('adult'),
              plan: PlanType.Individual,
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '₱ 150,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '₱ 30,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '₱ 50,000',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
            {
              label: t('children'),
              plan: PlanType.Family,
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '₱ 25,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '₱ 10,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '₱ 15,000',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
            {
              label: t('senior'),
              plan: PlanType.Senior,
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '₱ 5,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '₱ 15,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '₱ 25,000',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
          ],
        },
      },
      {
        baggageCoverage: {
          parentCoverage: {
            label: t('illness.description'),
            insuredAmountData: [
              {
                classId: 1,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 2,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 3,
                amount: '',
                remark: null,
                colspan: 1,
              },
            ],
          },
          childrenCoverage: [
            {
              label: t('adult'),
              plan: PlanType.Individual,
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
            {
              label: t('children'),
              plan: PlanType.Family,
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
            {
              label: t('senior'),
              plan: PlanType.Senior,
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
          ],
        },
      },
      {
        label: t('continue.description'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: '-' }),
            remark: null,
            colspan: 3
          },
        ],
      },
      {
        label: t('hospital.description'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: '-' }),
            remark: null,
            colspan: 3
          },
        ],
      },
      {
        label: t('quarantine.description'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount', { amount: '-' }),
            remark: null,
            colspan: 3
          },
        ],
      },
    ],
  };
};

export default InternationalPostTripMedical;
